import React from 'react';
import { Divider, Flex } from '@withjoy/joykit';
import { AccommodationListingDTO, AccommodationsConsoleState, Filters, SortOption } from '../../AccommodationsConsole.types';
import { ListingEntry } from './components/ListingEntry';
import { CoupleRecommendationsCheck } from './components/CoupleRecommendationsCheck';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';
import { SpecialEventRatesTag } from './components/SpecialEventRatesTag';
import DeskTopListingsHeader from './components/DeskTopListingsHeader';
import { pxToRem } from '@withjoy/joykit/theme';
import { ResetFiltersHeader } from './components/ResetFiltersHeader';

interface ListingsPanelProps
  extends Readonly<{
    hidePanel?: boolean;
    isLoadingPrices: boolean;
    listings: ReadonlyArray<AccommodationListingDTO>;
    state: AccommodationsConsoleState;
    sortOption: SortOption;
    onSortChange: (sort: SortOption) => void;
    noOfNights: number;
    filters: Filters;
    updateFilters: (filters: Filters) => void;
  }> {}

const Container: React.FC<{ hide?: boolean }> = ({ hide, children }) => {
  return (
    <Flex
      height="fit-content"
      flexDirection="column"
      display={hide ? 'none' : 'flex'}
      width={{ _: 'full', md: pxToRem(725) }}
      paddingLeft={6}
      paddingY={{ _: 6, sm2: 8 }}
      paddingRight={{ _: 6, sm2: 8 }}
      rowGap={{ _: 6, sm2: 8 }}
    >
      {children}
    </Flex>
  );
};

const ListingsPanel = (props: ListingsPanelProps) => {
  const { hidePanel, listings, state, noOfNights, sortOption, onSortChange, filters, updateFilters } = props;
  const isMobileOrTablet = useIsMobileOrTablet();

  return (
    <Container hide={hidePanel}>
      {isMobileOrTablet ? (
        <SpecialEventRatesTag />
      ) : (
        <DeskTopListingsHeader
          sortOption={sortOption}
          onSortChange={onSortChange}
        />
      )}
      <ResetFiltersHeader
        filters={filters}
        updateFilters={updateFilters}
      />
      {listings.map(listing => {
        return (
          <React.Fragment key={listing.id}>
            <ListingEntry
              state={state}
              listing={listing}
              noOfNights={noOfNights}
            />
            {!isMobileOrTablet && <Divider />}
          </React.Fragment>
        );
      })}
    </Container>
  );
};

ListingsPanel.Skeleton = ({ isMobileOrTablet }: { isMobileOrTablet: boolean }) => {
  return (
    <Container>
      {isMobileOrTablet ? <SpecialEventRatesTag.Skeleton /> : <CoupleRecommendationsCheck.Skeleton />}
      <ListingEntry.Skeleton isMobileOrTablet={isMobileOrTablet} />
      <Divider />
      <ListingEntry.Skeleton isMobileOrTablet={isMobileOrTablet} />
      <Divider />
      <ListingEntry.Skeleton isMobileOrTablet={isMobileOrTablet} />
      <Divider />
      <ListingEntry.Skeleton isMobileOrTablet={isMobileOrTablet} />
    </Container>
  );
};

export { ListingsPanel };
